"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungSubCategory = void 0;
var LeitungSubCategory;
(function (LeitungSubCategory) {
    // NetTech (Netzwerk-, Ethernet-, LWL-, Feldbus-Leitungen)
    LeitungSubCategory["NetTechDeviceNet"] = "NetTechDeviceNet";
    LeitungSubCategory["NetTechEthernet"] = "NetTechEthernet";
    LeitungSubCategory["NetTechFoc"] = "NetTechFoc";
    LeitungSubCategory["NetTechProfibus"] = "NetTechProfibus";
    LeitungSubCategory["NetTechProfinet"] = "NetTechProfinet";
    // VideoVisionBus (Video-, Vision-, Bustechnik) // TODO: sync with akeneo names / structure when clarified
    LeitungSubCategory["VideoVisionBusFireWire"] = "VideoVisionBusFireWire";
    LeitungSubCategory["VideoVisionBusUsb2_0"] = "VideoVisionBusUsb2_0";
    LeitungSubCategory["VideoVisionBusUsb3_0"] = "VideoVisionBusUsb3_0";
    LeitungSubCategory["VideoVisionBusGigE"] = "VideoVisionBusGigE";
    LeitungSubCategory["VideoVisionBusDviD_Hdmi"] = "VideoVisionBusDviD_Hdmi";
    LeitungSubCategory["VideoVisionBusCoax"] = "VideoVisionBusCoax";
    LeitungSubCategory["VideoVisionBusVga"] = "VideoVisionBusVga";
    // SensorActor (Sensor-, Aktorleitungen)
    LeitungSubCategory["SensorActorCf9_CfIni"] = "SensorActorCf9_CfIni";
    LeitungSubCategory["SensorActorCf10_CfIni"] = "SensorActorCf10_CfIni";
    LeitungSubCategory["SensorActorCf98_CfIni"] = "SensorActorCf98_CfIni";
    LeitungSubCategory["SensorActorConnectionCables"] = "SensorActorConnectionCables";
    // HartingIndustrialConnectors
    LeitungSubCategory["HartingHan6b"] = "HartingHan6b";
    LeitungSubCategory["HartingHan10b"] = "HartingHan10b";
    LeitungSubCategory["HartingHan16b"] = "HartingHan16b";
    LeitungSubCategory["HartingHan24b"] = "HartingHan24b";
    // Robotic (Leitungen für Roboter)
    LeitungSubCategory["RcRoboticKuka"] = "RcRoboticKuka";
    LeitungSubCategory["RcRoboticFanuc"] = "RcRoboticFanuc";
    LeitungSubCategory["RcRoboticAbb"] = "RcRoboticAbb";
    LeitungSubCategory["RcRoboticAida"] = "RcRoboticAida";
})(LeitungSubCategory = exports.LeitungSubCategory || (exports.LeitungSubCategory = {}));
//# sourceMappingURL=LeitungSubCategory.js.map